export default __webpack_public_path__ + "static/george_popovici-817f6da5bba291ee41e7f2f4cd1bb6a3.jpg";